<script setup lang="ts">
import FormServico from '../components/form-servico.vue'
import { useServicoStore } from '../store/useServicoStore'

definePage({
  meta: {
    navActiveLink: 'admin-servico',
    action: 'create',
    subject: 'servico',
  },
})

const { resetForm } = useServicoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormServico />
</template>
